import * as ACTION_TYPES from './action-types'
import * as MUTATIONS from './mutation-types'
import * as TABLE_MUTATIONS from '@/store/modules/Table/mutation-types'

import {
	executeSimpleQuery,
	executeMutation,
	executeQueryWithLoading
} from '@/store/helpers/apollo'

import FetchBillingCompanyDetail from './Schema/Queries/FetchBillingCompanyDetail.gql'
import FetchBillingCompanyDetails from './Schema/Queries/FetchBillingCompanyDetails.gql'
import FetchBillingCompanyDetailsMeta from './Schema/Queries/FetchBillingCompanyDetailsMeta.gql'
import FetchBillingAccountingExportConfig from './Schema/Queries/FetchBillingAccountingExportConfig.gql'
import FetchBillingDebetasDimensionDetail from './Schema/Queries/FetchBillingDebetasDimensionDetail.gql'
import FetchBillingDebetasDimensionDetails from './Schema/Queries/FetchBillingDebetasDimensionDetails.gql'
import FetchBillingDebetasDimensionHeader from './Schema/Queries/FetchBillingDebetasDimensionHeader.gql'
import FetchBillingDebetasDimensionHeaders from './Schema/Queries/FetchBillingDebetasDimensionHeaders.gql'
import FetchDebetasDimensionHeaderDataFields from './Schema/Queries/FetchDebetasDimensionHeaderDataFields.gql'
import FetchBillingDocumentConfig from './Schema/Queries/FetchBillingDocumentConfig.gql'
import FetchBillingDocumentConfigs from './Schema/Queries/FetchBillingDocumentConfigs.gql'
import FetchBillingDocumentConfigsMeta from './Schema/Queries/FetchBillingDocumentConfigsMeta.gql'
import FetchDocumentBuyerConfigs from './Schema/Queries/FetchDocumentBuyerConfigs.gql'
import FetchDocumentSellerConfigs from './Schema/Queries/FetchDocumentSellerConfigs.gql'
import FetchBillingDocumentItemDescriptions from './Schema/Queries/FetchBillingDocumentItemDescriptions.gql'
import FetchBillingDocumentItemDescriptionsMeta from './Schema/Queries/FetchBillingDocumentItemDescriptionsMeta.gql'
import FetchBillingDocumentItemDescriptionGroup from './Schema/Queries/FetchBillingDocumentItemDescriptionGroup.gql'
import FetchBillingDocumentItemDescriptionGroups from './Schema/Queries/FetchBillingDocumentItemDescriptionGroups.gql'
import FetchBillingDocumentItemDescriptionGroupsMeta from './Schema/Queries/FetchBillingDocumentItemDescriptionGroupsMeta.gql'
import FetchBillingCashRegisters from './Schema/Queries/FetchBillingCashRegisters.gql'
import FetchBillingCashRegistersMeta from './Schema/Queries/FetchBillingCashRegistersMeta.gql'
import FetchBillingRecord from './Schema/Queries/FetchBillingRecord.gql'
import FetchBillingRecords from './Schema/Queries/FetchBillingRecords.gql'
import FetchBillingRecordsMeta from './Schema/Queries/FetchBillingRecordsMeta.gql'
import FetchBillingRecordSearchSuggestions from './Schema/Queries/FetchBillingRecordSearchSuggestions.gql'
import FetchBillingSeriesPolicy from './Schema/Queries/FetchBillingSeriesPolicy.gql'
import FetchBillingSeriesPolicies from './Schema/Queries/FetchBillingSeriesPolicies.gql'
import FetchBillingSeriesPoliciesMeta from './Schema/Queries/FetchBillingSeriesPoliciesMeta.gql'
import ValidateDeleteBillingSeriesPolicy from './Schema/Queries/ValidateDeleteBillingSeriesPolicy.gql'
import ValidateVatNumber from './Schema/Queries/ValidateVatNumber.gql'
import CreateBillingCompanyDetail from './Schema/Mutations/CreateBillingCompanyDetail.gql'
import CreateBillingAccountingExportConfig from './Schema/Mutations/CreateBillingAccountingExportConfig.gql'
import CreateBillingCashRegister from './Schema/Mutations/CreateBillingCashRegister.gql'
import CreateBillingDocumentConfig from './Schema/Mutations/CreateBillingDocumentConfig.gql'
import CreateBillingDocumentItemDescription from './Schema/Mutations/CreateBillingDocumentItemDescription.gql'
import CreateBillingDocumentItemDescriptionGroup from './Schema/Mutations/CreateBillingDocumentItemDescriptionGroup.gql'
import CreateBillingRecord from './Schema/Mutations/CreateBillingRecord.gql'
import CreateBillingSeriesPolicy from './Schema/Mutations/CreateBillingSeriesPolicy.gql'
import UpdateBillingCompanyDetail from './Schema/Mutations/UpdateBillingCompanyDetail.gql'
import UpdateBillingCashRegister from './Schema/Mutations/UpdateBillingCashRegister.gql'
import UpdateBillingDocumentConfig from './Schema/Mutations/UpdateBillingDocumentConfig.gql'
import UpdateBillingDocumentItemDescription from './Schema/Mutations/UpdateBillingDocumentItemDescription.gql'
import UpdateBillingDocumentItemDescriptionGroup from './Schema/Mutations/UpdateBillingDocumentItemDescriptionGroup.gql'
import UpdateBillingRecord from './Schema/Mutations/UpdateBillingRecord.gql'
import UpdateBillingSeriesPolicy from './Schema/Mutations/UpdateBillingSeriesPolicy.gql'
import DeleteBillingCompanyDetail from './Schema/Mutations/DeleteBillingCompanyDetail.gql'
import DeleteBillingCashRegister from './Schema/Mutations/DeleteBillingCashRegister.gql'
import DeleteBillingDocumentConfig from './Schema/Mutations/DeleteBillingDocumentConfig.gql'
import DeleteBillingDocumentConfigLogo from './Schema/Mutations/DeleteBillingDocumentConfigLogo.gql'
import DeleteBillingDocumentItemDescription from './Schema/Mutations/DeleteBillingDocumentItemDescription.gql'
import DeleteBillingDocumentItemDescriptionGroup from './Schema/Mutations/DeleteBillingDocumentItemDescriptionGroup.gql'
import DeleteBillingRecord from './Schema/Mutations/DeleteBillingRecord.gql'
import DeleteBillingSeriesPolicy from './Schema/Mutations/DeleteBillingSeriesPolicy.gql'
import ReassignBillingSeriesPolicy from './Schema/Mutations/ReassignBillingSeriesPolicy.gql'
import AddDocumentBuyerConfig from './Schema/Mutations/AddDocumentBuyerConfig.gql'
import AddDocumentSellerConfig from './Schema/Mutations/AddDocumentSellerConfig.gql'
import RemoveDocumentBuyerConfig from './Schema/Mutations/RemoveDocumentBuyerConfig.gql'
import RemoveDocumentSellerConfig from './Schema/Mutations/RemoveDocumentSellerConfig.gql'
import UpdateDocumentBuyerConfigs from './Schema/Mutations/UpdateDocumentBuyerConfigs.gql'
import UpdateDocumentSellerConfigs from './Schema/Mutations/UpdateDocumentSellerConfigs.gql'
import AddDimensionHeader from './Schema/Mutations/AddDimensionHeader.gql'
import UpdateDimensionHeader from './Schema/Mutations/UpdateDimensionHeader.gql'
import DeleteDimensionHeader from './Schema/Mutations/DeleteDimensionHeader.gql'
import AddDimensionDetail from './Schema/Mutations/AddDimensionDetail.gql'
import UpdateDimensionDetail from './Schema/Mutations/UpdateDimensionDetail.gql'
import DeleteDimensionDetail from './Schema/Mutations/DeleteDimensionDetail.gql'
import DebetasBillingExport from './Schema/Mutations/DebetasBillingExport.gql'
import AccountingRegisterExport from './Schema/Mutations/AccountingRegisterExport.gql'
import AccountingDebetasCompareExport from './Schema/Mutations/AccountingDebetasCompareExport.gql'

const sortDocumentConfigItems = (items = []) => [...items].sort((a, b) => {
	const left = typeof a?.sequence === 'number' ? a.sequence : Number.MAX_SAFE_INTEGER
	const right = typeof b?.sequence === 'number' ? b.sequence : Number.MAX_SAFE_INTEGER
	return left - right
})

const syncBillingDocumentConfigCollection = ({ commit, state }, collectionKey, items) => {
	if (!state.billingDocumentConfig?.id) {
		return null
	}

	const billingDocumentConfig = {
		...state.billingDocumentConfig,
		[collectionKey]: sortDocumentConfigItems(items)
	}

	commit(MUTATIONS.SET_BILLING_DOCUMENT_CONFIG, billingDocumentConfig)

	if (Array.isArray(state.billingDocumentConfigs)) {
		const billingDocumentConfigs = state.billingDocumentConfigs.map(item => (
			item.id === billingDocumentConfig.id
				? { ...item, [collectionKey]: billingDocumentConfig[collectionKey] }
				: item
		))
		commit(MUTATIONS.SET_BILLING_DOCUMENT_CONFIGS, billingDocumentConfigs)
	}

	return billingDocumentConfig
}

const normalizeDepartmentIdsPayload = (payload = {}, fallbackDepartmentId = null) => {
	const normalizedPayload = { ...payload }
	const normalizedDepartmentIds = Array.isArray(normalizedPayload.departmentIds)
		? normalizedPayload.departmentIds.filter(Boolean)
		: normalizedPayload.departmentIds
			? [normalizedPayload.departmentIds].filter(Boolean)
			: []
	const resolvedDepartmentId = normalizedPayload.departmentId || fallbackDepartmentId

	if (normalizedDepartmentIds.length) {
		normalizedPayload.departmentIds = normalizedDepartmentIds
	} else if (resolvedDepartmentId) {
		normalizedPayload.departmentIds = [resolvedDepartmentId]
	} else {
		delete normalizedPayload.departmentIds
	}

	delete normalizedPayload.departmentId

	return normalizedPayload
}

const normalizeDepartmentIdPayload = (payload = {}, fallbackDepartmentId = null) => {
	const normalizedPayload = { ...payload }
	const normalizedDepartmentIds = Array.isArray(normalizedPayload.departmentIds)
		? normalizedPayload.departmentIds.filter(Boolean)
		: normalizedPayload.departmentIds
			? [normalizedPayload.departmentIds].filter(Boolean)
			: []
	const resolvedDepartmentId = normalizedPayload.departmentId || normalizedDepartmentIds[0] || fallbackDepartmentId

	if (resolvedDepartmentId) {
		normalizedPayload.departmentId = resolvedDepartmentId
	} else {
		delete normalizedPayload.departmentId
	}

	delete normalizedPayload.departmentIds

	return normalizedPayload
}

const syncBillingDocumentConfigLogoDeletion = ({ commit, state }, logoField) => {
	if (!state.billingDocumentConfig?.id || !logoField) {
		return null
	}

	const billingDocumentConfig = {
		...state.billingDocumentConfig,
		[logoField]: null
	}

	commit(MUTATIONS.SET_BILLING_DOCUMENT_CONFIG, billingDocumentConfig)

	if (Array.isArray(state.billingDocumentConfigs)) {
		const billingDocumentConfigs = state.billingDocumentConfigs.map(item => (
			item.id === billingDocumentConfig.id
				? { ...item, [logoField]: null }
				: item
		))
		commit(MUTATIONS.SET_BILLING_DOCUMENT_CONFIGS, billingDocumentConfigs)
	}

	return billingDocumentConfig
}

export default {
	async [ACTION_TYPES.VALIDATE_VAT_NUMBER] (_, payload) {
		const data = await executeSimpleQuery({
			query: ValidateVatNumber,
			variables: { payload }
		})

		return data.validateVatNumber
	},

	async [ACTION_TYPES.FETCH_BILLING_COMPANY_DETAILS] (
		{ commit, rootState },
		{ page = 1, size = 20, payload = {}, sort } = {}
	) {
		const queryPayload = normalizeDepartmentIdsPayload(
			payload,
			rootState?.Auth?.user?.selectedDepartmentId
		)

		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingCompanyDetails',
			query: {
				query: FetchBillingCompanyDetails,
				variables: {
					payload: queryPayload,
					page,
					size,
					sort
				}
			},
			onSuccess: (data) => {
				const billingCompanyDetails = data.billingCompanyDetails?.nodes || []
				commit(`Table/${TABLE_MUTATIONS.SET_DATA}`, billingCompanyDetails)
				commit(MUTATIONS.SET_BILLING_COMPANY_DETAILS, billingCompanyDetails)
				return data.billingCompanyDetails
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_COMPANY_DETAILS_META] (
		{ commit, state, rootState },
		{ page = 1, size = 20, payload = {}, sort } = {}
	) {
		const queryPayload = normalizeDepartmentIdsPayload(
			payload,
			rootState?.Auth?.user?.selectedDepartmentId
		)

		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingCompanyDetailsMeta',
			query: {
				query: FetchBillingCompanyDetailsMeta,
				variables: {
					payload: queryPayload,
					page,
					size,
					sort
				}
			},
			onSuccess: (data) => {
				const meta = data.billingCompanyDetailsMeta?.meta ?? state.billingCompanyDetailsMeta
				commit(MUTATIONS.SET_BILLING_COMPANY_DETAILS_META, meta)
				return meta
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_COMPANY_DETAIL] ({ commit }, id) {
		const data = await executeSimpleQuery({
			query: FetchBillingCompanyDetail,
			variables: { id }
		})

		commit(MUTATIONS.SET_BILLING_COMPANY_DETAIL, data.billingCompanyDetail)
		return data.billingCompanyDetail
	},

	async [ACTION_TYPES.CREATE_BILLING_COMPANY_DETAIL] ({ commit, state }, payload) {
		return executeMutation({
			mutation: {
				mutation: CreateBillingCompanyDetail,
				variables: { payload }
			},
			onSuccess: (data) => {
				const createdBillingCompanyDetail = data.createBillingCompanyDetail
				if (Array.isArray(state.billingCompanyDetails)) {
					const billingCompanyDetails = [createdBillingCompanyDetail, ...state.billingCompanyDetails]
					commit(`Table/${TABLE_MUTATIONS.SET_DATA}`, billingCompanyDetails)
					commit(MUTATIONS.SET_BILLING_COMPANY_DETAILS, billingCompanyDetails)
				}
				commit(MUTATIONS.SET_BILLING_COMPANY_DETAIL, createdBillingCompanyDetail)
				return createdBillingCompanyDetail
			}
		})
	},

	async [ACTION_TYPES.UPDATE_BILLING_COMPANY_DETAIL] ({ commit, state }, { id, payload }) {
		return executeMutation({
			mutation: {
				mutation: UpdateBillingCompanyDetail,
				variables: { id, payload }
			},
			onSuccess: (data) => {
				const updatedBillingCompanyDetail = data.updateBillingCompanyDetail
				if (Array.isArray(state.billingCompanyDetails)) {
					const billingCompanyDetails = state.billingCompanyDetails.map(item => (
						item.id === updatedBillingCompanyDetail.id ? updatedBillingCompanyDetail : item
					))
					commit(`Table/${TABLE_MUTATIONS.SET_DATA}`, billingCompanyDetails)
					commit(MUTATIONS.SET_BILLING_COMPANY_DETAILS, billingCompanyDetails)
				}
				commit(MUTATIONS.SET_BILLING_COMPANY_DETAIL, updatedBillingCompanyDetail)
				return updatedBillingCompanyDetail
			}
		})
	},

	async [ACTION_TYPES.DELETE_BILLING_COMPANY_DETAIL] ({ commit, state }, payload) {
		return executeMutation({
			mutation: {
				mutation: DeleteBillingCompanyDetail,
				variables: { payload }
			},
			onSuccess: (data) => {
				if (Array.isArray(state.billingCompanyDetails)) {
					const billingCompanyDetails = state.billingCompanyDetails.filter(item => item.id !== payload.id)
					commit(`Table/${TABLE_MUTATIONS.SET_DATA}`, billingCompanyDetails)
					commit(MUTATIONS.SET_BILLING_COMPANY_DETAILS, billingCompanyDetails)
					if (typeof state.billingCompanyDetailsMeta?.total === 'number') {
						commit(MUTATIONS.SET_BILLING_COMPANY_DETAILS_META, {
							...state.billingCompanyDetailsMeta,
							total: Math.max(state.billingCompanyDetailsMeta.total - 1, 0)
						})
					}
				}
				return data.deleteBillingCompanyDetail
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_SERIES_POLICIES] (
		{ commit, rootState },
		{ page = 1, size = 20, payload = {}, sort } = {}
	) {
		const queryPayload = normalizeDepartmentIdsPayload(
			payload,
			rootState?.Auth?.user?.selectedDepartmentId
		)

		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingSeriesPolicies',
			query: {
				query: FetchBillingSeriesPolicies,
				variables: {
					payload: queryPayload,
					page,
					size,
					sort
				}
			},
			onSuccess: (data) => {
				const billingSeriesPolicies = data.billingSeriesPolicies?.nodes || []
				commit(MUTATIONS.SET_BILLING_SERIES_POLICIES, billingSeriesPolicies)
				return data.billingSeriesPolicies
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_SERIES_POLICIES_META] (
		{ commit, state, rootState },
		{ page = 1, size = 20, payload = {}, sort } = {}
	) {
		const queryPayload = normalizeDepartmentIdsPayload(
			payload,
			rootState?.Auth?.user?.selectedDepartmentId
		)

		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingSeriesPoliciesMeta',
			query: {
				query: FetchBillingSeriesPoliciesMeta,
				variables: {
					payload: queryPayload,
					page,
					size,
					sort
				}
			},
			onSuccess: (data) => {
				const meta = data.billingSeriesPoliciesMeta?.meta ?? state.billingSeriesPoliciesMeta
				commit(MUTATIONS.SET_BILLING_SERIES_POLICIES_META, meta)
				return meta
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_SERIES_POLICY] ({ commit }, id) {
		const data = await executeSimpleQuery({
			query: FetchBillingSeriesPolicy,
			variables: { id }
		})

		commit(MUTATIONS.SET_BILLING_SERIES_POLICY, data.billingSeriesPolicy)
		return data.billingSeriesPolicy
	},

	async [ACTION_TYPES.FETCH_BILLING_SERIES_POLICIES_LOOKUP] (
		{ rootState },
		{ size = 200, payload = {}, sort } = {}
	) {
		const queryPayload = normalizeDepartmentIdsPayload(
			payload,
			rootState?.Auth?.user?.selectedDepartmentId
		)

		const nodes = []
		let page = 1
		let batch = []

		do {
			const data = await executeSimpleQuery({
				query: FetchBillingSeriesPolicies,
				variables: { payload: queryPayload, page, size, sort }
			})
			batch = data.billingSeriesPolicies?.nodes || []
			nodes.push(...batch)
			page += 1
		} while (batch.length === size)

		return nodes
	},

	async [ACTION_TYPES.FETCH_BILLING_CASH_REGISTERS] (
		{ commit, rootState },
		{ page = 1, size = 200, payload = {}, sort } = {}
	) {
		const queryPayload = normalizeDepartmentIdPayload(
			payload,
			rootState?.Auth?.user?.selectedDepartmentId
		)

		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingCashRegisters',
			query: {
				query: FetchBillingCashRegisters,
				variables: {
					payload: queryPayload,
					page,
					size,
					sort
				}
			},
			onSuccess: (data) => {
				const billingCashRegisters = data.billingCashRegisters?.nodes || []
				commit(MUTATIONS.SET_BILLING_CASH_REGISTERS, billingCashRegisters)
				return data.billingCashRegisters
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_CASH_REGISTERS_META] (
		{ commit, state, rootState },
		{ page = 1, size = 20, payload = {}, sort } = {}
	) {
		const queryPayload = normalizeDepartmentIdPayload(
			payload,
			rootState?.Auth?.user?.selectedDepartmentId
		)

		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingCashRegistersMeta',
			query: {
				query: FetchBillingCashRegistersMeta,
				variables: {
					payload: queryPayload,
					page,
					size,
					sort
				}
			},
			onSuccess: (data) => {
				const meta = data.billingCashRegistersMeta?.meta ?? state.billingCashRegistersMeta
				commit(MUTATIONS.SET_BILLING_CASH_REGISTERS_META, meta)
				return meta
			}
		})
	},

	async [ACTION_TYPES.CREATE_BILLING_SERIES_POLICY] ({ commit, state }, payload) {
		const mutationPayload = normalizeDepartmentIdPayload(payload)

		return executeMutation({
			mutation: {
				mutation: CreateBillingSeriesPolicy,
				variables: { payload: mutationPayload }
			},
			onSuccess: (data) => {
				const createdBillingSeriesPolicy = data.createBillingSeriesPolicy
				if (createdBillingSeriesPolicy && Array.isArray(state.billingSeriesPolicies)) {
					const billingSeriesPolicies = [createdBillingSeriesPolicy, ...state.billingSeriesPolicies].filter(Boolean)
					commit(MUTATIONS.SET_BILLING_SERIES_POLICIES, billingSeriesPolicies)
				}
				if (createdBillingSeriesPolicy) {
					commit(MUTATIONS.SET_BILLING_SERIES_POLICY, createdBillingSeriesPolicy)
				}
				return createdBillingSeriesPolicy
			}
		})
	},

	async [ACTION_TYPES.UPDATE_BILLING_SERIES_POLICY] ({ commit, state }, { id, payload }) {
		const mutationPayload = normalizeDepartmentIdPayload(payload)
		return executeMutation({
			mutation: {
				mutation: UpdateBillingSeriesPolicy,
				variables: { id, payload: mutationPayload }
			},
			onSuccess: (data) => {
				const updatedBillingSeriesPolicy = data.updateBillingSeriesPolicy
				if (updatedBillingSeriesPolicy && Array.isArray(state.billingSeriesPolicies)) {
					const billingSeriesPolicies = state.billingSeriesPolicies
						.map(item => (
							item && item.id === updatedBillingSeriesPolicy.id ? updatedBillingSeriesPolicy : item
						))
						.filter(Boolean)
					commit(MUTATIONS.SET_BILLING_SERIES_POLICIES, billingSeriesPolicies)
				}
				if (updatedBillingSeriesPolicy) {
					commit(MUTATIONS.SET_BILLING_SERIES_POLICY, updatedBillingSeriesPolicy)
				}
				return updatedBillingSeriesPolicy
			}
		})
	},

	async [ACTION_TYPES.DELETE_BILLING_SERIES_POLICY] ({ commit, state }, id) {
		return executeMutation({
			mutation: {
				mutation: DeleteBillingSeriesPolicy,
				variables: { payload: { id } }
			},
			onSuccess: (data) => {
				const deletedBillingSeriesPolicy = data.deleteBillingSeriesPolicy
				if (Array.isArray(state.billingSeriesPolicies)) {
					const billingSeriesPolicies = state.billingSeriesPolicies.filter(item => item.id !== deletedBillingSeriesPolicy?.id)
					commit(MUTATIONS.SET_BILLING_SERIES_POLICIES, billingSeriesPolicies)
					if (typeof state.billingSeriesPoliciesMeta?.total === 'number') {
						commit(MUTATIONS.SET_BILLING_SERIES_POLICIES_META, {
							...state.billingSeriesPoliciesMeta,
							total: Math.max(state.billingSeriesPoliciesMeta.total - 1, 0)
						})
					}
				}
				return deletedBillingSeriesPolicy
			}
		})
	},

	async [ACTION_TYPES.VALIDATE_DELETE_BILLING_SERIES_POLICY] (_, id) {
		const data = await executeSimpleQuery({
			query: ValidateDeleteBillingSeriesPolicy,
			variables: { id }
		})

		return data.validateDeleteBillingSeriesPolicy
	},

	async [ACTION_TYPES.FETCH_BILLING_SERIES_POLICY_OPTIONS] (
		{ rootState },
		{ page = 1, size = 200, payload = {}, sort } = {}
	) {
		const queryPayload = normalizeDepartmentIdsPayload(
			payload,
			rootState?.Auth?.user?.selectedDepartmentId
		)

		const data = await executeSimpleQuery({
			query: FetchBillingSeriesPolicies,
			variables: {
				payload: queryPayload,
				page,
				size,
				sort
			}
		})

		return data.billingSeriesPolicies?.nodes || []
	},

	async [ACTION_TYPES.REASSIGN_BILLING_SERIES_POLICY] (_, payload) {
		return executeMutation({
			mutation: {
				mutation: ReassignBillingSeriesPolicy,
				variables: { payload }
			},
			onSuccess: (data) => data.reassignBillingSeriesPolicy
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_DOCUMENT_CONFIGS] (
		{ commit, rootState },
		{ page = 1, size = 20, payload = {}, sort } = {}
	) {
		const queryPayload = normalizeDepartmentIdsPayload(
			payload,
			rootState?.Auth?.user?.selectedDepartmentId
		)

		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingDocumentConfigs',
			query: {
				query: FetchBillingDocumentConfigs,
				variables: {
					payload: queryPayload,
					page,
					size,
					sort
				}
			},
			onSuccess: (data) => {
				const billingDocumentConfigs = data.billingDocumentConfigs?.nodes || []
				commit(MUTATIONS.SET_BILLING_DOCUMENT_CONFIGS, billingDocumentConfigs)
				return data.billingDocumentConfigs
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_DOCUMENT_CONFIG_OPTIONS] (
		{ rootState },
		{ page = 1, size = 200, payload = {}, sort } = {}
	) {
		const queryPayload = normalizeDepartmentIdsPayload(
			payload,
			rootState?.Auth?.user?.selectedDepartmentId
		)

		const data = await executeSimpleQuery({
			query: FetchBillingDocumentConfigs,
			variables: {
				payload: queryPayload,
				page,
				size,
				sort
			}
		})

		return data.billingDocumentConfigs?.nodes || []
	},

	async [ACTION_TYPES.FETCH_BILLING_DOCUMENT_CONFIGS_META] (
		{ commit, state, rootState },
		{ page = 1, size = 20, payload = {}, sort } = {}
	) {
		const queryPayload = normalizeDepartmentIdsPayload(
			payload,
			rootState?.Auth?.user?.selectedDepartmentId
		)

		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingDocumentConfigsMeta',
			query: {
				query: FetchBillingDocumentConfigsMeta,
				variables: {
					payload: queryPayload,
					page,
					size,
					sort
				}
			},
			onSuccess: (data) => {
				const meta = data.billingDocumentConfigsMeta?.meta ?? state.billingDocumentConfigsMeta
				commit(MUTATIONS.SET_BILLING_DOCUMENT_CONFIGS_META, meta)
				return meta
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_DOCUMENT_CONFIG] ({ commit }, id) {
		const data = await executeSimpleQuery({
			query: FetchBillingDocumentConfig,
			variables: { id }
		})

		commit(MUTATIONS.SET_BILLING_DOCUMENT_CONFIG, data.billingDocumentConfig)
		return data.billingDocumentConfig
	},

	async [ACTION_TYPES.FETCH_BILLING_DOCUMENT_BUYER_CONFIGS] (_, id) {
		const data = await executeSimpleQuery({
			query: FetchDocumentBuyerConfigs,
			variables: { id }
		})

		return data.documentBuyerConfigs || []
	},

	async [ACTION_TYPES.ADD_BILLING_DOCUMENT_BUYER_CONFIG] ({ commit, state }, { documentConfigId, payload }) {
		return executeMutation({
			mutation: {
				mutation: AddDocumentBuyerConfig,
				variables: { documentConfigId, payload }
			},
			onSuccess: (data) => {
				const documentBuyerConfig = data.addDocumentBuyerConfig

				if (state.billingDocumentConfig?.id === documentConfigId) {
					syncBillingDocumentConfigCollection(
						{ commit, state },
						'buyerConfigs',
						[
							...(state.billingDocumentConfig?.buyerConfigs || []),
							documentBuyerConfig
						]
					)
				}

				return documentBuyerConfig
			}
		})
	},

	async [ACTION_TYPES.REMOVE_BILLING_DOCUMENT_BUYER_CONFIG] ({ commit, state }, documentBuyerConfigId) {
		return executeMutation({
			mutation: {
				mutation: RemoveDocumentBuyerConfig,
				variables: { documentBuyerConfigId }
			},
			onSuccess: (data) => {
				const removedDocumentBuyerConfig = data.removeDocumentBuyerConfig

				if (Array.isArray(state.billingDocumentConfig?.buyerConfigs)) {
					syncBillingDocumentConfigCollection(
						{ commit, state },
						'buyerConfigs',
						state.billingDocumentConfig.buyerConfigs.filter(item => item.id !== removedDocumentBuyerConfig?.id)
					)
				}

				return removedDocumentBuyerConfig
			}
		})
	},

	async [ACTION_TYPES.UPDATE_BILLING_DOCUMENT_BUYER_CONFIGS] ({ commit, state }, payload) {
		return executeMutation({
			mutation: {
				mutation: UpdateDocumentBuyerConfigs,
				variables: { payload }
			},
			onSuccess: (data) => {
				const updatedDocumentBuyerConfigs = data.updateDocumentBuyerConfigs || []

				if (Array.isArray(state.billingDocumentConfig?.buyerConfigs)) {
					const updatedIds = new Set(updatedDocumentBuyerConfigs.map(item => item.id))

					syncBillingDocumentConfigCollection(
						{ commit, state },
						'buyerConfigs',
						[
							...state.billingDocumentConfig.buyerConfigs.filter(item => !updatedIds.has(item.id)),
							...updatedDocumentBuyerConfigs
						]
					)
				}

				return updatedDocumentBuyerConfigs
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_DOCUMENT_SELLER_CONFIGS] (_, id) {
		const data = await executeSimpleQuery({
			query: FetchDocumentSellerConfigs,
			variables: { id }
		})

		return data.documentSellerConfigs || []
	},

	async [ACTION_TYPES.ADD_BILLING_DOCUMENT_SELLER_CONFIG] ({ commit, state }, { documentConfigId, payload }) {
		return executeMutation({
			mutation: {
				mutation: AddDocumentSellerConfig,
				variables: { documentConfigId, payload }
			},
			onSuccess: (data) => {
				const documentSellerConfig = data.addDocumentSellerConfig

				if (state.billingDocumentConfig?.id === documentConfigId) {
					syncBillingDocumentConfigCollection(
						{ commit, state },
						'sellerConfigs',
						[
							...(state.billingDocumentConfig?.sellerConfigs || []),
							documentSellerConfig
						]
					)
				}

				return documentSellerConfig
			}
		})
	},

	async [ACTION_TYPES.REMOVE_BILLING_DOCUMENT_SELLER_CONFIG] ({ commit, state }, documentSellerConfigId) {
		return executeMutation({
			mutation: {
				mutation: RemoveDocumentSellerConfig,
				variables: { documentSellerConfigId }
			},
			onSuccess: (data) => {
				const removedDocumentSellerConfig = data.removeDocumentSellerConfig

				if (Array.isArray(state.billingDocumentConfig?.sellerConfigs)) {
					syncBillingDocumentConfigCollection(
						{ commit, state },
						'sellerConfigs',
						state.billingDocumentConfig.sellerConfigs.filter(item => item.id !== removedDocumentSellerConfig?.id)
					)
				}

				return removedDocumentSellerConfig
			}
		})
	},

	async [ACTION_TYPES.UPDATE_BILLING_DOCUMENT_SELLER_CONFIGS] ({ commit, state }, payload) {
		return executeMutation({
			mutation: {
				mutation: UpdateDocumentSellerConfigs,
				variables: { payload }
			},
			onSuccess: (data) => {
				const updatedDocumentSellerConfigs = data.updateDocumentSellerConfigs || []

				if (Array.isArray(state.billingDocumentConfig?.sellerConfigs)) {
					const updatedIds = new Set(updatedDocumentSellerConfigs.map(item => item.id))

					syncBillingDocumentConfigCollection(
						{ commit, state },
						'sellerConfigs',
						[
							...state.billingDocumentConfig.sellerConfigs.filter(item => !updatedIds.has(item.id)),
							...updatedDocumentSellerConfigs
						]
					)
				}

				return updatedDocumentSellerConfigs
			}
		})
	},

	async [ACTION_TYPES.CREATE_BILLING_DOCUMENT_CONFIG] ({ commit, state, rootState }, payload) {
		const mutationPayload = normalizeDepartmentIdPayload(payload, rootState?.Auth?.user?.selectedDepartmentId)

		return executeMutation({
			mutation: {
				mutation: CreateBillingDocumentConfig,
				variables: { payload: mutationPayload }
			},
			onSuccess: (data) => {
				const createdBillingDocumentConfig = data.createBillingDocumentConfig
				if (Array.isArray(state.billingDocumentConfigs)) {
					const billingDocumentConfigs = [createdBillingDocumentConfig, ...state.billingDocumentConfigs]
					commit(MUTATIONS.SET_BILLING_DOCUMENT_CONFIGS, billingDocumentConfigs)
				}
				commit(MUTATIONS.SET_BILLING_DOCUMENT_CONFIG, createdBillingDocumentConfig)
				return createdBillingDocumentConfig
			}
		})
	},

	async [ACTION_TYPES.UPDATE_BILLING_DOCUMENT_CONFIG] ({ commit, state }, { id, payload }) {
		return executeMutation({
			mutation: {
				mutation: UpdateBillingDocumentConfig,
				variables: { id, payload }
			},
			onSuccess: (data) => {
				const updatedBillingDocumentConfig = data.updateBillingDocumentConfig
				if (Array.isArray(state.billingDocumentConfigs)) {
					const billingDocumentConfigs = state.billingDocumentConfigs.map(item => (
						item.id === updatedBillingDocumentConfig.id ? updatedBillingDocumentConfig : item
					))
					commit(MUTATIONS.SET_BILLING_DOCUMENT_CONFIGS, billingDocumentConfigs)
				}
				commit(MUTATIONS.SET_BILLING_DOCUMENT_CONFIG, updatedBillingDocumentConfig)
				return updatedBillingDocumentConfig
			}
		})
	},

	async [ACTION_TYPES.DELETE_BILLING_DOCUMENT_CONFIG_LOGO] ({ commit, state }, { id, payload }) {
		return executeMutation({
			mutation: {
				mutation: DeleteBillingDocumentConfigLogo,
				variables: { id, payload }
			},
			onSuccess: (data) => {
				if (!data?.deleteBillingDocumentConfigLogo?.status) {
					return data?.deleteBillingDocumentConfigLogo
				}

				const logoField = payload?.logo || null
				syncBillingDocumentConfigLogoDeletion({ commit, state }, logoField)
				return data.deleteBillingDocumentConfigLogo
			}
		})
	},

	async [ACTION_TYPES.DELETE_BILLING_DOCUMENT_CONFIG] ({ commit, state }, id) {
		return executeMutation({
			mutation: {
				mutation: DeleteBillingDocumentConfig,
				variables: { id }
			},
			onSuccess: (data) => {
				const deletedBillingDocumentConfig = data.deleteBillingDocumentConfig
				if (Array.isArray(state.billingDocumentConfigs)) {
					const billingDocumentConfigs = state.billingDocumentConfigs.filter(item => item.id !== deletedBillingDocumentConfig?.id)
					commit(MUTATIONS.SET_BILLING_DOCUMENT_CONFIGS, billingDocumentConfigs)
					if (typeof state.billingDocumentConfigsMeta?.total === 'number') {
						commit(MUTATIONS.SET_BILLING_DOCUMENT_CONFIGS_META, {
							...state.billingDocumentConfigsMeta,
							total: Math.max(state.billingDocumentConfigsMeta.total - 1, 0)
						})
					}
				}
				return deletedBillingDocumentConfig
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_DEBETAS_DIMENSION_DETAIL] ({ commit }, id) {
		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingDebetasDimensionDetail',
			query: {
				query: FetchBillingDebetasDimensionDetail,
				variables: { headerId: id }
			},
			onSuccess: (data) => {
				commit(MUTATIONS.SET_BILLING_DEBETAS_DIMENSION_DETAIL, data.billingDebetasDimensionDetail)
				return data.billingDebetasDimensionDetail
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_DEBETAS_DIMENSION_DETAILS] ({ commit }, id) {
		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingDebetasDimensionDetails',
			query: {
				query: FetchBillingDebetasDimensionDetails,
				variables: { headerId: id }
			},
			onSuccess: (data) => {
				const billingDebetasDimensionDetails = data.billingDebetasDimensionDetails || []
				commit(MUTATIONS.SET_BILLING_DEBETAS_DIMENSION_DETAILS, billingDebetasDimensionDetails)
				return billingDebetasDimensionDetails
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_DEBETAS_DIMENSION_HEADER] ({ commit }, id) {
		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingDebetasDimensionHeader',
			query: {
				query: FetchBillingDebetasDimensionHeader,
				variables: { headerId: id }
			},
			onSuccess: (data) => {
				commit(MUTATIONS.SET_BILLING_DEBETAS_DIMENSION_HEADER, data.billingDebetasDimensionHeader)
				return data.billingDebetasDimensionHeader
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_DEBETAS_DIMENSION_HEADERS] ({ commit }, id) {
		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingDebetasDimensionHeaders',
			query: {
				query: FetchBillingDebetasDimensionHeaders,
				variables: { id }
			},
			onSuccess: (data) => {
				const billingDebetasDimensionHeaders = data.billingDebetasDimensionHeaders || []
				commit(MUTATIONS.SET_BILLING_DEBETAS_DIMENSION_HEADERS, billingDebetasDimensionHeaders)
				return billingDebetasDimensionHeaders
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_DEBETAS_DIMENSION_HEADER_DATA_FIELDS] ({ commit }) {
		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingDebetasDimensionHeaderDataFields',
			query: {
				query: FetchDebetasDimensionHeaderDataFields
			},
			onSuccess: (data) => {
				const billingDebetasDimensionHeaderDataFields = data.debetasDimensionHeaderDataFields || []
				commit(MUTATIONS.SET_BILLING_DEBETAS_DIMENSION_HEADER_DATA_FIELDS, billingDebetasDimensionHeaderDataFields)
				return billingDebetasDimensionHeaderDataFields
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_RECORDS] (
		{ commit, rootState },
		{ page = 1, size = 20, payload = {}, sort } = {}
	) {
		const queryPayload = normalizeDepartmentIdsPayload(
			payload,
			rootState?.Auth?.user?.selectedDepartmentId
		)

		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingRecords',
			query: {
				query: FetchBillingRecords,
				variables: {
					payload: queryPayload,
					page,
					size,
					sort
				}
			},
			onSuccess: (data) => {
				const billingRecords = data.billingRecords?.nodes || []
				commit(MUTATIONS.SET_BILLING_RECORDS, billingRecords)
				return data.billingRecords
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_RECORDS_META] (
		{ commit, state, rootState },
		{ page = 1, size = 20, payload = {}, sort } = {}
	) {
		const queryPayload = normalizeDepartmentIdsPayload(
			payload,
			rootState?.Auth?.user?.selectedDepartmentId
		)

		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingRecordsMeta',
			query: {
				query: FetchBillingRecordsMeta,
				variables: {
					payload: queryPayload,
					page,
					size,
					sort
				}
			},
			onSuccess: (data) => {
				const meta = data.billingRecordsMeta?.meta ?? state.billingRecordsMeta
				commit(MUTATIONS.SET_BILLING_RECORDS_META, meta)
				return meta
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_RECORD_SEARCH_SUGGESTIONS] (
		{ rootState },
		{ searchPhrase, field, departmentIds = [] } = {}
	) {
		const payload = normalizeDepartmentIdsPayload(
			{ departmentIds },
			rootState?.Auth?.user?.selectedDepartmentId
		)
		payload.searchPhrase = searchPhrase
		payload.field = field

		const data = await executeSimpleQuery({
			query: FetchBillingRecordSearchSuggestions,
			variables: { payload }
		})

		return data.billingRecordSearchSuggestions?.nodes || []
	},

	async [ACTION_TYPES.FETCH_BILLING_RECORD] ({ commit }, billingInvoiceId) {
		const data = await executeSimpleQuery({
			query: FetchBillingRecord,
			variables: {
				payload: {
					billingInvoiceId
				}
			}
		})

		commit(MUTATIONS.SET_BILLING_RECORD, data.billingRecord)
		return data.billingRecord
	},

	async [ACTION_TYPES.CREATE_BILLING_RECORD] ({ commit, state, rootState }, payload) {
		const mutationPayload = normalizeDepartmentIdPayload(payload, rootState?.Auth?.user?.selectedDepartmentId)

		return executeMutation({
			mutation: {
				mutation: CreateBillingRecord,
				variables: { payload: mutationPayload }
			},
			onSuccess: (data) => {
				const createdBillingRecord = data.createBillingRecord
				if (Array.isArray(state.billingRecords)) {
					const billingRecords = [createdBillingRecord, ...state.billingRecords]
					commit(MUTATIONS.SET_BILLING_RECORDS, billingRecords)
				}
				commit(MUTATIONS.SET_BILLING_RECORD, createdBillingRecord)
				return createdBillingRecord
			}
		})
	},

	async [ACTION_TYPES.UPDATE_BILLING_RECORD] ({ commit, state }, { id, payload }) {
		return executeMutation({
			mutation: {
				mutation: UpdateBillingRecord,
				variables: { id, payload }
			},
			onSuccess: (data) => {
				const updatedBillingRecord = data.updateBillingRecord
				if (Array.isArray(state.billingRecords)) {
					const billingRecords = state.billingRecords.map(item => (
						item.id === updatedBillingRecord.id ? updatedBillingRecord : item
					))
					commit(MUTATIONS.SET_BILLING_RECORDS, billingRecords)
				}
				commit(MUTATIONS.SET_BILLING_RECORD, updatedBillingRecord)
				return updatedBillingRecord
			}
		})
	},

	async [ACTION_TYPES.DELETE_BILLING_RECORD] ({ commit, state }, payload) {
		return executeMutation({
			mutation: {
				mutation: DeleteBillingRecord,
				variables: { payload }
			},
			onSuccess: (data) => {
				if (Array.isArray(state.billingRecords)) {
					const billingRecords = state.billingRecords.filter(item => item.id !== payload.id)
					commit(MUTATIONS.SET_BILLING_RECORDS, billingRecords)
					if (typeof state.billingRecordsMeta?.total === 'number') {
						commit(MUTATIONS.SET_BILLING_RECORDS_META, {
							...state.billingRecordsMeta,
							total: Math.max(state.billingRecordsMeta.total - 1, 0)
						})
					}
				}
				if (state.billingRecord?.id === payload.id) {
					commit(MUTATIONS.SET_BILLING_RECORD, null)
				}
				return data.deleteBillingRecord
			}
		})
	},

	async [ACTION_TYPES.CREATE_BILLING_CASH_REGISTER] ({ commit, state }, payload) {
		return executeMutation({
			mutation: {
				mutation: CreateBillingCashRegister,
				variables: { payload }
			},
			onSuccess: (data) => {
				const createdBillingCashRegister = data.createBillingCashRegister
				if (createdBillingCashRegister && Array.isArray(state.billingCashRegisters)) {
					const billingCashRegisters = [createdBillingCashRegister, ...state.billingCashRegisters]
					commit(MUTATIONS.SET_BILLING_CASH_REGISTERS, billingCashRegisters)
					if (typeof state.billingCashRegistersMeta?.total === 'number') {
						commit(MUTATIONS.SET_BILLING_CASH_REGISTERS_META, {
							...state.billingCashRegistersMeta,
							total: state.billingCashRegistersMeta.total + 1
						})
					}
				}
				return createdBillingCashRegister
			}
		})
	},

	async [ACTION_TYPES.UPDATE_BILLING_CASH_REGISTER] ({ commit, state }, { id, payload }) {
		return executeMutation({
			mutation: {
				mutation: UpdateBillingCashRegister,
				variables: { id, payload }
			},
			onSuccess: (data) => {
				const updatedBillingCashRegister = data.updateBillingCashRegister
				if (updatedBillingCashRegister && Array.isArray(state.billingCashRegisters)) {
					const billingCashRegisters = state.billingCashRegisters.map(item => (
						item.id === updatedBillingCashRegister.id ? updatedBillingCashRegister : item
					))
					commit(MUTATIONS.SET_BILLING_CASH_REGISTERS, billingCashRegisters)
				}
				return updatedBillingCashRegister
			}
		})
	},

	async [ACTION_TYPES.DELETE_BILLING_CASH_REGISTER] ({ commit, state }, payload) {
		return executeMutation({
			mutation: {
				mutation: DeleteBillingCashRegister,
				variables: { payload }
			},
			onSuccess: (data) => {
				if (Array.isArray(state.billingCashRegisters)) {
					const billingCashRegisters = state.billingCashRegisters.filter(item => `${item.id}` !== `${payload.id}`)
					commit(MUTATIONS.SET_BILLING_CASH_REGISTERS, billingCashRegisters)
					if (typeof state.billingCashRegistersMeta?.total === 'number') {
						commit(MUTATIONS.SET_BILLING_CASH_REGISTERS_META, {
							...state.billingCashRegistersMeta,
							total: Math.max(state.billingCashRegistersMeta.total - 1, 0)
						})
					}
				}
				return data.deleteBillingCashRegister
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_ACCOUNTING_EXPORT_CONFIG] ({ commit }, departmentId) {
		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingAccountingExportConfig',
			query: {
				query: FetchBillingAccountingExportConfig,
				variables: { departmentId }
			},
			onSuccess: (data) => {
				commit(MUTATIONS.SET_BILLING_ACCOUNTING_EXPORT_CONFIG, data.billingAccountingExportConfig)
				return data.billingAccountingExportConfig
			}
		})
	},

	async [ACTION_TYPES.CREATE_BILLING_ACCOUNTING_EXPORT_CONFIG] ({ commit }, payload) {
		return executeMutation({
			mutation: {
				mutation: CreateBillingAccountingExportConfig,
				variables: { payload }
			},
			onSuccess: (data) => {
				const billingAccountingExportConfig = data.createBillingAccountingExportConfig
				commit(MUTATIONS.SET_BILLING_ACCOUNTING_EXPORT_CONFIG, billingAccountingExportConfig)
				return billingAccountingExportConfig
			}
		})
	},

	async [ACTION_TYPES.ADD_BILLING_DEBETAS_DIMENSION_HEADER] ({ commit, state }, { accountingExportConfigId, payload }) {
		return executeMutation({
			mutation: {
				mutation: AddDimensionHeader,
				variables: { id: accountingExportConfigId, payload }
			},
			onSuccess: (data) => {
				const addedHeader = data.addDebetasDimensionHeader
				if (addedHeader && Array.isArray(state.billingDebetasDimensionHeaders)) {
					const billingDebetasDimensionHeaders = [...state.billingDebetasDimensionHeaders, addedHeader]
					commit(MUTATIONS.SET_BILLING_DEBETAS_DIMENSION_HEADERS, billingDebetasDimensionHeaders)
				}
				return addedHeader
			}
		})
	},

	async [ACTION_TYPES.UPDATE_BILLING_DEBETAS_DIMENSION_HEADER] ({ commit, state }, { id, payload }) {
		return executeMutation({
			mutation: {
				mutation: UpdateDimensionHeader,
				variables: { id, payload }
			},
			onSuccess: (data) => {
				const updatedHeader = data.updateDebetasDimensionHeader
				if (updatedHeader && Array.isArray(state.billingDebetasDimensionHeaders)) {
					const billingDebetasDimensionHeaders = state.billingDebetasDimensionHeaders.map(item => (
						item.id === updatedHeader.id ? updatedHeader : item
					))
					commit(MUTATIONS.SET_BILLING_DEBETAS_DIMENSION_HEADERS, billingDebetasDimensionHeaders)
				}
				return updatedHeader
			}
		})
	},

	async [ACTION_TYPES.DELETE_BILLING_DEBETAS_DIMENSION_HEADER] ({ commit, state }, id) {
		return executeMutation({
			mutation: {
				mutation: DeleteDimensionHeader,
				variables: { id }
			},
			onSuccess: (data) => {
				if (Array.isArray(state.billingDebetasDimensionHeaders)) {
					const billingDebetasDimensionHeaders = state.billingDebetasDimensionHeaders.filter(item => `${item.id}` !== `${id}`)
					commit(MUTATIONS.SET_BILLING_DEBETAS_DIMENSION_HEADERS, billingDebetasDimensionHeaders)
				}
				return data.deleteDebetasDimensionHeader
			}
		})
	},

	async [ACTION_TYPES.ADD_BILLING_DEBETAS_DIMENSION_DETAIL] ({ commit, state }, { id, payload }) {
		return executeMutation({
			mutation: {
				mutation: AddDimensionDetail,
				variables: { id, payload }
			},
			onSuccess: (data) => {
				const addedDetail = data.addDebetasDimensionDetail
				if (addedDetail && Array.isArray(state.billingDebetasDimensionDetails)) {
					const billingDebetasDimensionDetails = [...state.billingDebetasDimensionDetails, addedDetail]
					commit(MUTATIONS.SET_BILLING_DEBETAS_DIMENSION_DETAILS, billingDebetasDimensionDetails)
				}
				return addedDetail
			}
		})
	},

	async [ACTION_TYPES.UPDATE_BILLING_DEBETAS_DIMENSION_DETAIL] ({ commit, state }, { id, payload }) {
		return executeMutation({
			mutation: {
				mutation: UpdateDimensionDetail,
				variables: { id, payload }
			},
			onSuccess: (data) => {
				const updatedDetail = data.updateDimensionDetail
				if (updatedDetail && Array.isArray(state.billingDebetasDimensionDetails)) {
					const billingDebetasDimensionDetails = state.billingDebetasDimensionDetails.map(item => (
						item.id === updatedDetail.id ? updatedDetail : item
					))
					commit(MUTATIONS.SET_BILLING_DEBETAS_DIMENSION_DETAILS, billingDebetasDimensionDetails)
				}
				return updatedDetail
			}
		})
	},

	async [ACTION_TYPES.DELETE_BILLING_DEBETAS_DIMENSION_DETAIL] ({ commit, state }, id) {
		return executeMutation({
			mutation: {
				mutation: DeleteDimensionDetail,
				variables: { id }
			},
			onSuccess: (data) => {
				if (Array.isArray(state.billingDebetasDimensionDetails)) {
					const billingDebetasDimensionDetails = state.billingDebetasDimensionDetails.filter(item => `${item.id}` !== `${id}`)
					commit(MUTATIONS.SET_BILLING_DEBETAS_DIMENSION_DETAILS, billingDebetasDimensionDetails)
				}
				return data.deleteDebetasDimensionDetail
			}
		})
	},

	async [ACTION_TYPES.DEBETAS_BILLING_EXPORT] (_, payload) {
		return executeMutation({
			mutation: {
				mutation: DebetasBillingExport,
				variables: { payload }
			},
			onSuccess: (data) => data.debetasBillingExport
		})
	},

	async [ACTION_TYPES.ACCOUNTING_DEBETAS_COMPARE_EXPORT] (_, payload) {
		return executeMutation({
			mutation: {
				mutation: AccountingDebetasCompareExport,
				variables: { payload }
			},
			onSuccess: (data) => data.accountingDebetasCompareExport
		})
	},

	async [ACTION_TYPES.EXPORT_ACCOUNTING_REGISTER] (_, payload) {
		return executeMutation({
			mutation: {
				mutation: AccountingRegisterExport,
				variables: { payload }
			},
			onSuccess: (data) => data.accountingRegisterExport
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_DOCUMENT_ITEM_DESCRIPTIONS] (
		{ commit },
		{ page = 1, size = 20, payload = {}, sort } = {}
	) {
		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingDocumentItemDescriptions',
			query: {
				query: FetchBillingDocumentItemDescriptions,
				variables: {
					payload,
					page,
					size,
					sort
				}
			},
			onSuccess: (data) => {
				const billingDocumentItemDescriptions = data.billingDocumentItemDescriptions?.nodes || []
				commit(MUTATIONS.SET_BILLING_DOCUMENT_ITEM_DESCRIPTIONS, billingDocumentItemDescriptions)
				return data.billingDocumentItemDescriptions
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_DOCUMENT_ITEM_DESCRIPTIONS_META] (
		{ commit, state },
		{ page = 1, size = 20, payload = {}, sort } = {}
	) {
		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingDocumentItemDescriptionsMeta',
			query: {
				query: FetchBillingDocumentItemDescriptionsMeta,
				variables: {
					payload,
					page,
					size,
					sort
				}
			},
			onSuccess: (data) => {
				const meta = data.billingDocumentItemDescriptionsMeta?.meta ?? state.billingDocumentItemDescriptionsMeta
				commit(MUTATIONS.SET_BILLING_DOCUMENT_ITEM_DESCRIPTIONS_META, meta)
				return meta
			}
		})
	},

	async [ACTION_TYPES.CREATE_BILLING_DOCUMENT_ITEM_DESCRIPTION] ({ commit, state }, payload) {
		return executeMutation({
			mutation: {
				mutation: CreateBillingDocumentItemDescription,
				variables: { payload }
			},
			onSuccess: (data) => {
				const createdBillingDocumentItemDescription = data.createBillingDocumentItemDescription
				if (Array.isArray(state.billingDocumentItemDescriptions)) {
					const billingDocumentItemDescriptions = [createdBillingDocumentItemDescription, ...state.billingDocumentItemDescriptions]
					commit(MUTATIONS.SET_BILLING_DOCUMENT_ITEM_DESCRIPTIONS, billingDocumentItemDescriptions)
				}
				return createdBillingDocumentItemDescription
			}
		})
	},

	async [ACTION_TYPES.UPDATE_BILLING_DOCUMENT_ITEM_DESCRIPTION] ({ commit, state }, { id, payload }) {
		return executeMutation({
			mutation: {
				mutation: UpdateBillingDocumentItemDescription,
				variables: { id, payload }
			},
			onSuccess: (data) => {
				const updatedBillingDocumentItemDescription = data.updateBillingDocumentItemDescription
				if (updatedBillingDocumentItemDescription && Array.isArray(state.billingDocumentItemDescriptions)) {
					const billingDocumentItemDescriptions = state.billingDocumentItemDescriptions.map(item => (
						item.id === updatedBillingDocumentItemDescription.id ? updatedBillingDocumentItemDescription : item
					))
					commit(MUTATIONS.SET_BILLING_DOCUMENT_ITEM_DESCRIPTIONS, billingDocumentItemDescriptions)
				}
				return updatedBillingDocumentItemDescription
			}
		})
	},

	async [ACTION_TYPES.DELETE_BILLING_DOCUMENT_ITEM_DESCRIPTION] ({ commit, state }, id) {
		return executeMutation({
			mutation: {
				mutation: DeleteBillingDocumentItemDescription,
				variables: { id }
			},
			onSuccess: (data) => {
				if (Array.isArray(state.billingDocumentItemDescriptions)) {
					const billingDocumentItemDescriptions = state.billingDocumentItemDescriptions.filter(item => item.id !== id)
					commit(MUTATIONS.SET_BILLING_DOCUMENT_ITEM_DESCRIPTIONS, billingDocumentItemDescriptions)
					if (typeof state.billingDocumentItemDescriptionsMeta?.total === 'number') {
						commit(MUTATIONS.SET_BILLING_DOCUMENT_ITEM_DESCRIPTIONS_META, {
							...state.billingDocumentItemDescriptionsMeta,
							total: Math.max(state.billingDocumentItemDescriptionsMeta.total - 1, 0)
						})
					}
				}
				return data.deleteBillingDocumentItemDescription
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUP] ({ commit }, id) {
		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingDocumentItemDescriptionGroup',
			query: {
				query: FetchBillingDocumentItemDescriptionGroup,
				variables: { id }
			},
			onSuccess: (data) => {
				const billingDocumentItemDescriptionGroup = data.billingDocumentItemDescriptionGroup || {}
				commit(MUTATIONS.SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUP, billingDocumentItemDescriptionGroup)
				return billingDocumentItemDescriptionGroup
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUPS] (
		{ commit, rootState },
		{ page = 1, size = 20, payload = {}, sort } = {}
	) {
		const queryPayload = normalizeDepartmentIdsPayload(
			payload,
			rootState?.Auth?.user?.selectedDepartmentId
		)

		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingDocumentItemDescriptionGroups',
			query: {
				query: FetchBillingDocumentItemDescriptionGroups,
				variables: {
					payload: queryPayload,
					page,
					size,
					sort
				}
			},
			onSuccess: (data) => {
				const billingDocumentItemDescriptionGroups = data.billingDocumentItemDescriptionGroups?.nodes || []
				commit(MUTATIONS.SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUPS, billingDocumentItemDescriptionGroups)
				return data.billingDocumentItemDescriptionGroups
			}
		})
	},

	async [ACTION_TYPES.FETCH_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUPS_META] (
		{ commit, state, rootState },
		{ page = 1, size = 20, payload = {}, sort } = {}
	) {
		const queryPayload = normalizeDepartmentIdsPayload(
			payload,
			rootState?.Auth?.user?.selectedDepartmentId
		)

		return executeQueryWithLoading({
			commit,
			mutationName: MUTATIONS.SET_LOADING,
			loadingKey: 'billingDocumentItemDescriptionGroupsMeta',
			query: {
				query: FetchBillingDocumentItemDescriptionGroupsMeta,
				variables: {
					payload: queryPayload,
					page,
					size,
					sort
				}
			},
			onSuccess: (data) => {
				const meta = data.billingDocumentItemDescriptionGroupsMeta?.meta ?? state.billingDocumentItemDescriptionGroupsMeta
				commit(MUTATIONS.SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUPS_META, meta)
				return meta
			}
		})
	},

	async [ACTION_TYPES.CREATE_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUP] ({ commit, state, rootState }, payload) {
		const mutationPayload = normalizeDepartmentIdPayload(
			payload,
			payload?.departmentId || rootState?.Auth?.user?.selectedDepartmentId
		)

		return executeMutation({
			mutation: {
				mutation: CreateBillingDocumentItemDescriptionGroup,
				variables: { payload: mutationPayload }
			},
			onSuccess: (data) => {
				const createdBillingDocumentItemDescriptionGroup = data.createBillingDocumentItemDescriptionGroup
				if (Array.isArray(state.billingDocumentItemDescriptionGroups)) {
					const billingDocumentItemDescriptionGroups = [createdBillingDocumentItemDescriptionGroup, ...state.billingDocumentItemDescriptionGroups]
					commit(MUTATIONS.SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUPS, billingDocumentItemDescriptionGroups)
				}
				commit(MUTATIONS.SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUP, createdBillingDocumentItemDescriptionGroup)
				return createdBillingDocumentItemDescriptionGroup
			}
		})
	},

	async [ACTION_TYPES.UPDATE_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUP] ({ commit, state }, { id, payload }) {
		return executeMutation({
			mutation: {
				mutation: UpdateBillingDocumentItemDescriptionGroup,
				variables: { id, payload }
			},
			onSuccess: (data) => {
				const updatedBillingDocumentItemDescriptionGroup = data.updateBillingDocumentItemDescriptionGroup
				if (Array.isArray(state.billingDocumentItemDescriptionGroups)) {
					const billingDocumentItemDescriptionGroups = state.billingDocumentItemDescriptionGroups.map(item => (
						item.id === updatedBillingDocumentItemDescriptionGroup.id ? updatedBillingDocumentItemDescriptionGroup : item
					))
					commit(MUTATIONS.SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUPS, billingDocumentItemDescriptionGroups)
				}
				commit(MUTATIONS.SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUP, updatedBillingDocumentItemDescriptionGroup)
				return updatedBillingDocumentItemDescriptionGroup
			}
		})
	},

	async [ACTION_TYPES.DELETE_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUP] ({ commit, state }, id) {
		return executeMutation({
			mutation: {
				mutation: DeleteBillingDocumentItemDescriptionGroup,
				variables: { id }
			},
			onSuccess: (data) => {
				if (Array.isArray(state.billingDocumentItemDescriptionGroups)) {
					const billingDocumentItemDescriptionGroups = state.billingDocumentItemDescriptionGroups.filter(item => item.id !== id)
					commit(MUTATIONS.SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUPS, billingDocumentItemDescriptionGroups)
					if (typeof state.billingDocumentItemDescriptionGroupsMeta?.total === 'number') {
						commit(MUTATIONS.SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUPS_META, {
							...state.billingDocumentItemDescriptionGroupsMeta,
							total: Math.max(state.billingDocumentItemDescriptionGroupsMeta.total - 1, 0)
						})
					}
				}
				return data.deleteBillingDocumentItemDescriptionGroup
			}
		})
	}
}
